import { Routes } from '@angular/router';

import { v2On } from '../v2/ui-v2.guard';

export const paymentsRoutes: Routes = [
  {
    path: 'payments',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/payments/payments-v2.page').then(m => m.PaymentsV2Page),
  },
  {
    path: 'payments',
    loadComponent: () => import('./payments.page').then(m => m.PaymentsPage),
  },
];
